export interface BirthdayTextProps {
  customerName: string;
  /** Optional personalized message written by the rep, appended in its own paragraph. */
  personalMessage?: string;
  /** Optional sender name to sign off the text. */
  senderName?: string;
}

const firstName = (fullName: string): string => {
  const parts = (fullName || '').trim().split(/\s+/).filter(Boolean);
  return parts[0] || 'friend';
};

/**
 * Build a short, friendly birthday SMS. Returns plain text suitable for SMS.
 */
export const birthdayText = async (
  params: BirthdayTextProps,
): Promise<{ body: string }> => {
  const { customerName, personalMessage, senderName } = params;
  const greetingName = firstName(customerName);
  const personal = (personalMessage || '').trim();

  const sections = [
    `Happy birthday, ${greetingName}! 🎉 Everyone at Optic Truck Works is wishing you a great day.`,
  ];

  if (personal) sections.push(personal);

  sections.push(
    senderName
      ? `– ${senderName}, Optic Truck Works`
      : '– The Optic Truck Works Team',
  );

  return { body: sections.join('\n\n') };
};
